import { Form, useFormikContext } from 'formik'
import { Heading, VStack } from 'native-base'
import * as yup from 'yup'

import PhoneFormPhoneNumberSVG from '../../../assets/PhoneFormPhoneNumberSVG'
import { isPhoneNumberValid } from '@consumer/shared'
import i18n from '../../../i18n'
import MaskedTextInput from '../Form/Input/MaskedTextInput'
import { TermsAndConditions, TermsAndConditionsFormType, tcFormSchema } from '../TermAndConditions/TermsAndConditions'

const typeErrorString = i18n.t('common:VALIDATION.TYPE_ERROR_STRING')
const phoneRequired = 'Phone number is required.'
const phoneValid = i18n.t('common:VALIDATION.PHONE_NUMBER')

export const phoneFormSchema = tcFormSchema.clone().shape({
  phoneNumber: yup
    .string()
    .typeError(typeErrorString)
    .required(phoneRequired)
    .test('is-phone-number', phoneValid, value => isPhoneNumberValid(value)),
})

export type PhoneFormType = TermsAndConditionsFormType & {
  phoneNumber: string
}

export const PhoneInput = ({ termsAndConditionsAction }: { termsAndConditionsAction?: string }) => {
  const { handleChange, handleBlur, values, errors } = useFormikContext<PhoneFormType>()

  return (
    <Form style={{ alignItems: 'stretch', width: '100%' }}>
      <VStack alignItems={'stretch'} space={4}>
        <VStack alignItems={'center'}>
          <PhoneFormPhoneNumberSVG />
        </VStack>
        <Heading size={'sm'} textAlign={'center'}>
          Enter your phone number and we'll text you a verification code.
        </Heading>
        <MaskedTextInput
          autoComplete="tel"
          textContentType="telephoneNumber"
          borderWidth={2}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.phoneNumber}
          keyboardType="phone-pad"
          mask="+1 (999) 999-9999"
          name="phoneNumber"
          placeholder="(___) ___-____"
          value={values.phoneNumber}
          borderColor={'brand.softBlack'}
          autoFocus={true}
        />
        <TermsAndConditions action={termsAndConditionsAction} />
      </VStack>
    </Form>
  )
}
